module.exports = __webpack_public_path__ + "img/stock3.ba43a8e0.png";